import "./HotelAdsPaidMediaServices.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Coverage from "./sections/Coverage";
import Campaign from "./sections/Campaign";
import Footer from "@/reusable_sections/Footer";
export default function HotelAdsPaidMediaServicesPage() {
  return <div>
      <Header />
      <Hero />
      <Coverage />
      <Campaign />
      <Footer />
    </div>;
}